export default "__VITE_ASSET__CqWz3Bni__"